/* Search safety rules match the Router contract. These are hints, never VIN decoding. */
(function(window) {
  'use strict';
  var PS = window.PS = window.PS || {};
  var partialPrefixes = /^(1HG|1FA|1FT|1G1|1G2|1GC|1GT|2HG|2T1|3VW|4T1|5YJ|JHM|JTD|JN1|KMH|WBA|WBS|WDB|WDC|WVW|WAU|YV1)/;
  var sessionKey = 'ps_search_session_v1';

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return window.location.hostname === 'www.paintscratch.com' && privacy &&
      typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
  }

  function searchSession(create) {
    try {
      if (!analyticsAllowed()) { window.sessionStorage.removeItem(sessionKey); return null; }
      var session = JSON.parse(window.sessionStorage.getItem(sessionKey) || 'null');
      var now = new Date().getTime();
      if (session && (typeof session.id !== 'string' || !/^[a-z0-9]{1,12}-[a-z0-9]{1,8}$/.test(session.id) ||
        typeof session.started !== 'number' || !isFinite(session.started) || !session.sent || typeof session.sent !== 'object')) session = null;
      if (session && (now - session.started > 1800000 || now < session.started)) session = null;
      if (!session && create) session = { id: now.toString(36) + '-' + Math.random().toString(36).slice(2, 10), started: now, sent: {} };
      if (session) window.sessionStorage.setItem(sessionKey, JSON.stringify(session));
      else window.sessionStorage.removeItem(sessionKey);
      return session;
    } catch (_e) { return null; }
  }

  // Fixed categories only. No query text, URLs, VINs, or query hashes enter analytics.
  function track(stage, data, surface, selection) {
    try {
      var api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== 'function') return;
      var session = searchSession(true);
      if (!session || !/^(eligible|shown|selected)$/.test(stage)) return;
      var intent = data && data.intent ? data.intent.type : 'general';
      if (!/^(general|vin_help|order_help|product_format|code_help|return_help|mismatch_help|repair_help)$/.test(intent)) intent = 'general';
      var state = data && data.status ? data.status : 'ok';
      if (!/^(ok|no_results|action_required|unavailable)$/.test(state)) state = 'ok';
      selection = /^[a-z_]{1,40}$/.test(selection || '') ? selection : '';
      surface = surface === 'results' ? 'results' : 'suggestions';
      var key = stage + ':' + intent + ':' + state + ':' + surface + ':' + selection;
      if (session.sent[key]) return;
      session.sent[key] = true;
      window.sessionStorage.setItem(sessionKey, JSON.stringify(session));
      var count = data && data.totalFound ? data.totalFound : (data && data.suggestions ? data.suggestions.length : 0);
      var published = api.publish('paintscratch:search_outcome', {
        search_session_id: session.id, version: 1, stage: stage, surface: surface,
        intent: intent, status: state, selection_type: selection,
        result_count: count === 0 ? 'zero' : count <= 6 ? 'one_to_six' : 'seven_plus'
      });
      if (published && typeof published.catch === 'function') published.catch(function() {});
    } catch (_e) {}
  }

  function classifySensitive(value) {
    var text = String(value || '').replace(/[\x00-\x1f\x7f]+/g, ' ').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    var compact = text.toUpperCase().replace(/[\s-]/g, '');
    var identifiers = text.toUpperCase().match(/\b[A-Z0-9]{17}\b/g) || [];
    var tokenIndex;
    var vehiclePhrase;
    var productPhrase;
    // Hub /api/shopify/makes/all?v=2, 2026-09-28: intent recognition only, not fitment.
    var make = '(?:acura|alfa[ -]romeo|alumacraft|amc|american[ -]coach|amg|aston[ -]martin|audi|austin|beaver|bentley|bmc|bmw|bmw[ -]motorcycles' +
      '|buick|cadillac|chevrolet|chrysler|citro[e\\u00eb]n|coachmen[ -]rv|corbin|daewoo|daihatsu|dodge|drv|ducati|duckworth|eagle' +
      '|edsel|ferrari|fiat|fleet|fleetwood|fluidesign|ford|forest[ -]river|fountain|four[ -]winns|freightliner|fujidesign|genesis|gmc' +
      '|harley[ -]davidson|honda|honda[ -]motorcycle|hummer|hyundai|infiniti|international|isata|isuzu|itasca|jaguar|jeep|kia|laforza' +
      '|lamborghini|lancia|land[ -]rover|lexus|lincoln|lotus|lund|macdon|maserati|mazda|mercedes[ -]benz|mercury|merkur|mg' +
      '|mini|mitsubishi|morgan|new[ -]holland|newmar|nissan|oldsmobile|opel|packard|pantera|peterbilt|peugeot|plymouth|pontiac' +
      '|porsche|ral|renault|rivian|rolls[ -]royce|rover[ -]sterling|rv[ -]other|saab|saturn|scion|seat|smart|sterling|subaru' +
      '|suzuki|suzuki[ -]motorcycle|tesla|toyota|travel|triumph|volkswagen|volvo|winnebago|yamaha)';
    var vehiclePhrasePattern = new RegExp('^(?:' + make + '\\s+(?:19|20)\\d{2}|(?:19|20)\\d{2}\\s+' + make + ')\\s+([a-z0-9]+(?:[ -][a-z0-9]+)*)$', 'i');
    var vehicleModel;
    if (/[^\s@]+@[^\s@]+\.[^\s@]+/.test(text)) return 'sensitive_contact';
    if (/\b(?:order|tracking)\s*(?:number|no\.?|id|#)?\s*[:#-]?\s*[a-z]*\d{4,}\b/i.test(text)) return 'sensitive_order';
    if (/^(?:vin|vehicle identification number)$/i.test(text) || /^vin\s/i.test(text) || /\b(?:by|from|using|with|my|the|a)\s+vin\b|\bvin\s+(?:lookup|number|paint|code)\b|\b(?:find|decode|enter|check)\s+(?:my\s+)?vin\b/i.test(text)) return 'explicit_vin';
    for (tokenIndex = 0; tokenIndex < identifiers.length; tokenIndex++) {
      if (/[A-Z]/.test(identifiers[tokenIndex]) && /[0-9]/.test(identifiers[tokenIndex])) return /^[A-HJ-NPR-Z0-9]+$/.test(identifiers[tokenIndex]) ? 'vin_like' : 'possible_vin';
    }
    productPhrase = /\b(?:paint|spray|can|pen|bottle|kit|part|code)\b/i.test(text);
    if (!productPhrase && /^[A-Z0-9]{17}$/.test(compact) && /[A-Z]/.test(compact) && /[0-9]/.test(compact)) {
      if (/^[A-HJ-NPR-Z0-9]{17}$/.test(compact)) return 'vin_like';
      // Only an invalid-alphabet compacted candidate may be an ordinary vehicle phrase.
      vehiclePhrase = vehiclePhrasePattern.exec(text);
      vehicleModel = vehiclePhrase ? vehiclePhrase[1] : '';
      return vehicleModel && /(?:^|[ -])[a-z]{3,}(?:[ -]|$)/i.test(vehicleModel) ? '' : 'possible_vin';
    }
    if (!productPhrase && /^[A-Z0-9]{8,16}$/.test(compact) && partialPrefixes.test(compact)) return 'possible_vin';
    return '';
  }

  function sensitiveData(value, reason) {
    reason = reason || classifySensitive(value);
    if (!reason) return null;
    var support = reason === 'sensitive_contact' || reason === 'sensitive_order';
    return {
      contract_version: 1, status: 'action_required', query: '', query_redacted: true,
      intent: { type: support ? 'order_help' : 'vin_help', reason: reason },
      results: [], suggestions: [], groups: [], totalFound: 0, totalPages: 1, page: 1,
      actions: support ? [
        {id:'order_help',kind:'link',label:'Get help with your order',url:'/support/check.htm'}
      ] : [
        {id:'find_paint_code',kind:'link',label:'Where to find my paint code',url:'/touch-up-paint-codes/paint-code.html'},
        {id:'choose_vehicle',kind:'vehicle_selector',label:'Filter by vehicle',url:'/'},
        {id:'label_photo',kind:'link',label:'Upload a color label photo',url:'/pages/help-me-find-my-color?photo=paint_label#ps-paint-label-help'}
      ]
    };
  }

  function guidanceText(data) {
    var type = data && data.intent ? data.intent.type : '';
    if (type === 'vin_help') {
      return "VINs do not contain the paint color. Instead, search using your vehicle's paint code.";
    }
    if (data && data.query_redacted) return 'Use our order help page for private order details.';
    if (type === 'product_format') return data.context_verified ? 'Paint products for your selected color.' : 'Choose your paint color before you pick a paint product.';
    if (type === 'repair_help') return 'Start with these guides to plan your repair.';
    if (type === 'code_help') return 'Start with the paint code on your vehicle.';
    if (type === 'order_help') return 'Find your order or get help with it.';
    if (type === 'return_help' || type === 'mismatch_help') return 'See the steps for getting help with your order.';
    return '';
  }

  function safeActionUrl(value) {
    var url = String(value || '');
    if (/^https:\/\/www\.paintscratch\.com\//i.test(url)) url = url.replace(/^https:\/\/www\.paintscratch\.com/i, '');
    return /^\/(?!\/)/.test(url) && !/[\x00-\x20\\]/.test(url) ? url : '/search';
  }

  function vehicleContext() {
    var saved = {};
    var current = null;
    var scope = {};
    var keys = ['make', 'year', 'model'];
    var index;
    var match;
    var value;
    try { if (PS.cc && typeof PS.cc.read === 'function') saved = PS.cc.read() || {}; } catch (_e) {}
    try { if (typeof PS.ssr === 'function') current = PS.ssr(); } catch (_e2) {}
    if (current && current.valid && current.make && current.make !== saved.make) saved = {make:current.make};
    for (index = 0; index < keys.length; index++) {
      value = saved[keys[index]] || '';
      match = String(window.location.search || '').match(new RegExp('(?:^|[?&])' + keys[index] + '=([^&]*)'));
      try { if (match) value = decodeURIComponent(match[1].replace(/\+/g, ' ')); } catch (_e3) { value = ''; }
      value = String(value);
      if (/^[a-z0-9 .()'\-\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff]{1,60}$/i.test(value) && !classifySensitive(value) && (keys[index] !== 'year' || /^\d{4}$/.test(value))) scope[keys[index]] = value;
    }
    if (String(scope.make || '').toLowerCase() !== String(saved.make || '').toLowerCase()) {
      if (!/(?:^|[?&])year=/.test(window.location.search || '')) delete scope.year;
      if (!/(?:^|[?&])model=/.test(window.location.search || '')) delete scope.model;
    } else if (scope.year !== String(saved.year || '') && !/(?:^|[?&])model=/.test(window.location.search || '')) delete scope.model;
    return scope;
  }

  function withVehicle(url) {
    var scope = vehicleContext();
    var params = [];
    var key;
    var hash = url.indexOf('#') === -1 ? '' : url.slice(url.indexOf('#'));
    if (hash) url = url.slice(0, url.indexOf('#'));
    for (key in scope) if (Object.prototype.hasOwnProperty.call(scope, key) && !new RegExp('(?:[?&])' + key + '=').test(url)) params.push(key + '=' + encodeURIComponent(scope[key]));
    return url + (params.length ? (url.indexOf('?') === -1 ? '?' : '&') + params.join('&') : '') + hash;
  }

  PS.Search = {
    classifySensitive: classifySensitive,
    sensitiveData: sensitiveData,
    guidanceText: guidanceText,
    safeActionUrl: safeActionUrl,
    vehicleContext: vehicleContext,
    withVehicle: withVehicle,
    track: track,
    sessionId: function() { var session = searchSession(false); return session ? session.id : ''; },
    helpUrl: function(reason) { return withVehicle('/search?help=' + (reason === 'sensitive_contact' || reason === 'sensitive_order' ? 'order' : 'vin')); }
  };
})(window);
